import React, { useEffect, useState } from "react";
import { MyVerticallyCenteredModal } from "./common/WalletModal";
import { useAccount } from "wagmi";
import { Link } from "react-router-dom";
import { TARGET_TOKEN_VALUE, TARGET_TOKEN_SOLD } from "../confiq";
import ProgressBar from "react-bootstrap/ProgressBar";
import millify from "millify";
import { getTokenSold } from "../api/api";

const Hero = () => {
  const [modalShow, setModalShow] = useState(false);
  const { isConnected } = useAccount();
  const [animate, setAnimate] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [tokenSold, setTokensSold] = useState("");

  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const calculatePercentage = () => {
    const num = (TARGET_TOKEN_SOLD / TARGET_TOKEN_VALUE) * 100;

    return num.toFixed(2);
  };

  useEffect(() => {
    const fetchTokenSold = async () => {
      try {
        const response = await getTokenSold();

        if (response.data.data.tokenSold) {
          setTokensSold(response.data.data.tokenSold);
        }
      } catch (error) {
        console.error("Error fetching token sold data:", error);
      }
    };

    fetchTokenSold();
  }, []);
  return (
    <>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <section className="Hero">
        <div className="Background">
          <div className="Rectangle-One" />
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="Content">
                <div className="Heading">
                  <h2 className="heading-class">
                    Fuel Tomorrow's Projects Today
                  </h2>
                </div>

                {showContent && (
                  <>
                    <div className="Desc slide-in">
                      <p>
                        Crowdfund the future with a powerful, zero-fee,
                        validator-backed crypto platform.
                      </p>
                    </div>
                    <div className="hero-btns justify-content-center slide-in mt-5">
                      {!isConnected ? (
                        <button
                          className="btn-black"
                          onClick={() => setModalShow(true)}
                        >
                          Join The Presale
                          <svg
                            width="23"
                            height="23"
                            viewBox="0 0 23 23"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1_406)">
                              <path
                                d="M11.6985 11.8731L8.12346 8.29812C7.95546 8.13012 7.87146 7.91612 7.87146 7.65612C7.87146 7.39712 7.95546 7.18312 8.12346 7.01512C8.29146 6.84712 8.50546 6.76312 8.76546 6.76312C9.02446 6.76312 9.23846 6.84712 9.40646 7.01512L13.6235 11.2311C13.7155 11.3231 13.7805 11.4221 13.8185 11.5291C13.8575 11.6361 13.8765 11.7511 13.8755 11.8731C13.8745 11.9951 13.8565 12.1101 13.8185 12.2171C13.7815 12.3241 13.7165 12.4231 13.6235 12.5151L9.40646 16.7311C9.23846 16.8991 9.02446 16.9831 8.76546 16.9831C8.50546 16.9831 8.29146 16.8991 8.12346 16.7311C7.95546 16.5631 7.87146 16.3491 7.87146 16.0901C7.87146 15.8301 7.95546 15.6161 8.12346 15.4481L11.6985 11.8731Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1_406">
                                <rect
                                  width="22"
                                  height="22"
                                  fill="white"
                                  transform="translate(0.148438 0.873108)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </button>
                      ) : (
                        <Link
                          to={"/buy"}
                          className="btn-black flex-row hero-go"
                        >
                          Go To Buy
                          <svg
                            width="23"
                            height="23"
                            viewBox="0 0 23 23"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1_406)">
                              <path
                                d="M11.6985 11.8731L8.12346 8.29812C7.95546 8.13012 7.87146 7.91612 7.87146 7.65612C7.87146 7.39712 7.95546 7.18312 8.12346 7.01512C8.29146 6.84712 8.50546 6.76312 8.76546 6.76312C9.02446 6.76312 9.23846 6.84712 9.40646 7.01512L13.6235 11.2311C13.7155 11.3231 13.7805 11.4221 13.8185 11.5291C13.8575 11.6361 13.8765 11.7511 13.8755 11.8731C13.8745 11.9951 13.8565 12.1101 13.8185 12.2171C13.7815 12.3241 13.7165 12.4231 13.6235 12.5151L9.40646 16.7311C9.23846 16.8991 9.02446 16.9831 8.76546 16.9831C8.50546 16.9831 8.29146 16.8991 8.12346 16.7311C7.95546 16.5631 7.87146 16.3491 7.87146 16.0901C7.87146 15.8301 7.95546 15.6161 8.12346 15.4481L11.6985 11.8731Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1_406">
                                <rect
                                  width="22"
                                  height="22"
                                  fill="white"
                                  transform="translate(0.148438 0.873108)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </Link>
                      )}
                      <a
                        // href="https://drive.google.com/file/d/1p9jaWulP1X-i_6v38RMpM172HMXx6J3Q/view?usp=sharing"
                        href="https://presale.openfundtoken.io/whitepaper/OFNT-Whitepaper-updated.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="white-paper-btn"
                        style={{ border: "none", padding: "0px 0px" }}
                      >
                        <button className="btn-outline">WHITEPAPER</button>
                      </a>
                    </div>
                    <div className="slide-in">{/* <Heroslider />s */}</div>
                  </>
                )}
                {showContent && (
                  <div className="mt-5 content hero-content-main slide-in">
                    <div className="left-content hero-content">
                      <h3>The Smarter Way to Crowdfund</h3>
                      <p>
                        OpenFundNet is a decentralized platform that connects
                        innovative project owners with a community of passionate
                        backers and powerful validators. With daily token
                        rewards, transparent governance, and zero platform fees,
                        OFNT is redefining crypto crowdfunding.
                      </p>
                    </div>
                    <div className="right-content hero-content">
                      <h3>Built for Builders. Powered by the Community.</h3>
                      <ul>
                        <li>Project Owners: Propose. Launch. Get funded.</li>
                        <li>Backers: Support projects. Earn daily rewards.</li>
                        <li>Validators: Secure the network. Guide quality.</li>
                        <li>Nominators: Delegate power. Shape the future.</li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          {showContent && (
            <div className="progress-card d-flex flex-column align-content-center justify-content-center gap-3 mx-auto hero-content-ani">
              <div className="pro-text d-flex flex-row align-content-center justify-content-between w-100">
                <p>Stage 1:</p>
                <p>1 OFNT = 0.01 USDT</p>
              </div>
              <div className="w-100 mx-auto landing-progress">
                <div className="progress">
                  <ProgressBar now={calculatePercentage()} />
                  <span>
                    {tokenSold} / {millify(TARGET_TOKEN_VALUE)} OFNT
                  </span>
                </div>
              </div>
              <div className="pro-text d-flex flex-row align-content-center justify-content-between w-100">
                <p>OFNT SOLD:</p>
                <p>{tokenSold}</p>
              </div>
            </div>
          )}
        </div>
      </section>

      {showVideoModal && (
        <div className="video-modal">
          <div
            className="video-modal-overlay"
            onClick={() => setShowVideoModal(false)}
          />
          <div className="video-modal-content">
            <button
              className="close-btn"
              onClick={() => setShowVideoModal(false)}
            >
              ✖
            </button>
            <video controls autoPlay>
              <source src="/videos/intro.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}

      <style jsx>{`
        .video-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(0, 0, 0, 0.8);
          z-index: 1000;
        }
        .video-modal-overlay {
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
        }
        .video-modal-content {
          position: relative;
          width: 80%;
          max-width: 800px;
          background: #000;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
        }
        .video-modal video {
          width: 100%;
          border-radius: 8px;
        }
        .close-btn {
          position: absolute;
          top: 10px;
          right: 15px;
          background: transparent;
          color: white;
          font-size: 24px;
          border: none;
          cursor: pointer;
        }
      `}</style>
    </>
  );
};

export default Hero;
